<template>
  <div class="packageFee column-me">
    <div class="card-div column-me flex1">
      <div class="column-me flex1">
        <div>
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style">
            <el-table-column prop="preType" label="处方类型" align="center"></el-table-column>
            <el-table-column prop="name" label="剂型" align="center"></el-table-column>
            <el-table-column label="内包材费" align="center">
              <el-table-column label="剂/贴数" align="center">
                <template #default="scope">
                  {{ scope.row.chargeType ? '' : scope.row.number }}
                </template>
              </el-table-column>
              <el-table-column label="处方" align="center">
                <template #default="scope">
                  {{ scope.row.chargeType ? scope.row.number : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="money" label="包材费" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="外包材费" align="center">
              <el-table-column label="剂/贴数" align="center">
                <template #default="scope">
                  {{ scope.row.chargeType1 ? '' : scope.row.number1 }}
                </template>
              </el-table-column>
              <el-table-column label="处方" align="center">
                <template #default="scope">
                  {{ scope.row.chargeType1 ? scope.row.number1 : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="money1" label="包材费" align="center"></el-table-column>
            </el-table-column>

            <el-table-column label="操作列" align="center" width="180" v-if="canOperate">
              <template #default="scope">
                <div class="row-me center-all">
                  <div class="btn-blue width100 btn-height40" @click="clickEdit(scope.row)">
                    <el-icon>
                      <edit/>
                    </el-icon>
                    编辑
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>


    <!-- 编辑 -->
    <el-dialog title="编辑" v-model="visible" width="45%" :destroy-on-close="true" top="5vh">
      <div class="padding20">
        <div class="column-me height100per">
          <div class="row-me row-center">
            <div>处方类型：{{ selectItem.preType }}</div>
            <div class="margin-left80">剂型：{{ selectItem.name }}</div>
          </div>
          <div>
            <div class="row-me row-center margin-top35">
              <div class="blue-line"></div>
              <div class="blue-title margin-left10">内包材费</div>
            </div>
            <div class="row-me row-center margin-top30">
              <div class="title-div" v-if="selectItem.name==='中医外治'">贴数：</div>
              <div class="title-div" v-else>剂数：</div>
              <div class="input-div">
                <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.number"
                          @input="jiShuChange"
                          :class="{'red-border':showRedBorder&&$method.isEmpty(selectItem.number)}"
                          :disabled="selectItem.chargeType">
                </el-input>
              </div>
              <el-checkbox v-model="selectItem.chargeType" @change="typeChange"
                           :disabled="selectItem.type==='g'||selectItem.type==='w'||selectItem.type==='s'">
                按处方收费
              </el-checkbox>
            </div>
            <div class="row-me row-center margin-top30">
              <div class="title-div">包材费：</div>
              <div class="input-div">
                <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.money"
                          @input="selectItem.money=this.$method.checkInput(selectItem.money,2)"
                          :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.money)}">
                </el-input>
              </div>
              <div>元</div>
            </div>
          </div>
          <div class="margin-top40">
            <div class="row-me row-center">
              <div class="blue-line"></div>
              <div class="blue-title margin-left10">外包材费</div>
            </div>
            <div class="row-me row-center margin-top30">
              <div class="title-div" v-if="selectItem.name==='中医外治'">贴数：</div>
              <div class="title-div" v-else>剂数：</div>
              <div class="input-div">
                <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.number1"
                          @input="jiShuChange"
                          :class="{'red-border':showRedBorder&&$method.isEmpty(selectItem.number1)}"
                          :disabled="selectItem.chargeType1">
                </el-input>
              </div>
              <el-checkbox v-model="selectItem.chargeType1" @change="typeChange1"
                           :disabled="selectItem.type==='g'||selectItem.type==='w'||selectItem.type==='s'">
                按处方收费
              </el-checkbox>
            </div>
            <div class="row-me row-center margin-top30">
              <div class="title-div">包材费：</div>
              <div class="input-div">
                <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.money1"
                          @input="selectItem.money1=this.$method.checkInput(selectItem.money1,2)"
                          :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.money1)}">
                </el-input>
              </div>
              <div>元</div>
            </div>
          </div>
          <div class="margin-top30">泡沫箱&冰袋收费标准：</div>
          <div class="margin-top20" v-if="selectItem.foamBoxes">
            <el-table :data="selectItem.foamBoxes" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style">
              <el-table-column label="最小值(剂)" align="center">
                <template #header>
                  <div v-if="selectItem.type==='g'||selectItem.type==='w'||selectItem.type==='s'">最小值(g)</div>
                  <div v-else>最小值(剂)</div>
                </template>
                <template #default='scope'>
                  <div class="flex1">
                    <el-input placeholder="请输入" style="width: 100%;" clearable
                              @input="scope.row.minNum=this.$method.checkInput(scope.row.minNum,3)"
                              v-if="selectItem.type==='g'||selectItem.type==='w'||selectItem.type==='s'"
                              v-model="scope.row.minNum"></el-input>
                    <el-input placeholder="请输入" style="width: 100%;" clearable
                              @input="scope.row.minNum=this.$method.checkInput(scope.row.minNum,0)"
                              v-else v-model="scope.row.minNum"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="最大值(剂)" align="center">
                <template #header>
                  <div v-if="selectItem.type==='g'||selectItem.type==='w'||selectItem.type==='s'">最大值(g)</div>
                  <div v-else>最大值(剂)</div>
                </template>
                <template #default='scope'>
                  <div class="flex1">
                    <el-input placeholder="请输入" style="width: 100%;" clearable
                              @input="scope.row.maxNum=this.$method.checkInput(scope.row.maxNum,3)"
                              v-if="selectItem.type==='g'||selectItem.type==='w'||selectItem.type==='s'"
                              v-model="scope.row.maxNum"></el-input>
                    <el-input placeholder="请输入" style="width: 100%;" clearable
                              @input="scope.row.maxNum=this.$method.checkInput(scope.row.maxNum,0)"
                              v-else v-model="scope.row.maxNum"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="dictName" label="泡沫箱规格" align="center"></el-table-column>
              <el-table-column label="泡沫箱收费金额" align="center" width="150">
                <template #default='scope'>
                  <div class="flex1">
                    <el-input placeholder="请输入" style="width: 100%;" clearable
                              @input="scope.row.framPrice=this.$method.checkInput(scope.row.framPrice,2)"
                              v-model="scope.row.framPrice"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="冰袋个数" align="center">
                <template #default='scope'>
                  <div class="flex1">
                    <el-input placeholder="请输入" style="width: 100%;" clearable
                              @input="scope.row.iceNum=this.$method.checkInput(scope.row.iceNum,0)"
                              v-model="scope.row.iceNum"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="icePrice" label="冰袋收费金额" align="center" width="150">
                <template #default='scope'>
                  {{ this.$method.toFixed(Number(scope.row.configPrice) * Number(scope.row.iceNum), 2) }}
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="row-me flex-end1 margin-top50">
            <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visible: false,
      tableData: [],
      showRedBorder: false,
      editId: '',
      selectItem: {},
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    jiShuChange() {
      this.selectItem.number = this.$method.checkInput(this.selectItem.number, 0)
      this.selectItem.number1 = this.$method.checkInput(this.selectItem.number1, 0)
      if (this.selectItem.number === 0 || this.selectItem.number === '0') {
        this.selectItem.number = ''
      }
      if (this.selectItem.number1 === 0 || this.selectItem.number1 === '0') {
        this.selectItem.number1 = ''
      }
    },
    typeChange(e) {
      if (e) {
        this.selectItem.number = 1
      }
    },
    typeChange1(e) {
      if (e) {
        this.selectItem.number1 = 1
      }
    },
    clickSave() {
      if (this.$method.isEmpty(this.selectItem.number) || this.$method.isEmpty(this.selectItem.money) ||
          this.$method.isEmpty(this.selectItem.number1) || this.$method.isEmpty(this.selectItem.money1)) {
        this.showRedBorder = true
        return
      }
      if (this.selectItem.foamBoxes && this.selectItem.foamBoxes.length !== 0) {
        for (let i = 0; i < this.selectItem.foamBoxes.length; i++) {
          let item = this.selectItem.foamBoxes[i]
          if (this.$method.isEmpty(item.minNum) || this.$method.isEmpty(item.maxNum) || this.$method.isEmpty(item.framPrice) || this.$method.isEmpty(item.iceNum)) {
            this.$message.error("第" + (i + 1) + "行请输入完整")
            return;
          }
          item.icePrice = this.$method.toFixed(Number(item.configPrice) * Number(item.iceNum), 2)
        }
      }
      this.$postRequest('/admin/systemConfig/updateConfig', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visible = false
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickCancel() {
      this.visible = false
    },
    clickEdit(item) {
      this.editId = item.id
      this.getDetail()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/systemConfig/getConfigList', {
        type: 0
      }).then((res) => {
        if (res) {
          this.tableData = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取详情数据
    getDetail() {
      this.$getRequest('/admin/systemConfig/getInfo', {
        id: this.editId
      }).then((res) => {
        if (res) {
          let typeName = res.data.name
          if (typeName.indexOf('膏剂') !== -1) {
            res.data.type = 'g'
          } else if (typeName.indexOf('丸剂') !== -1) {
            res.data.type = 'w'
          } else if (typeName.indexOf('散剂') !== -1) {
            res.data.type = 's'
          } else if (typeName.indexOf('颗粒剂') !== -1) {
            res.data.type = 'k'
          } else if (typeName.indexOf('汤剂') !== -1) {
            res.data.type = 't'
          } else if (typeName.indexOf('外用制剂') !== -1) {
            res.data.type = 'wy'
          }
          this.selectItem = res.data
          this.showRedBorder = false
          this.visible = true
          if (this.selectItem.type === 'g' || this.selectItem.type === 'w' || this.selectItem.type === 's') {
            this.selectItem.number = 1
            this.selectItem.number1 = 1
            this.selectItem.chargeType = true
            this.selectItem.chargeType1 = true
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.packageFee {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
  }

  .title-div {
    width: 90px;
    text-align: right;
  }

  .input-div {
    width: 486px;
    margin-right: 20px;
  }
}
</style>
